import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import CustomTextField from '../CustomFields/CustomTextField';
import { validationEmbarazoForm, validationForm } from "./ValidationForm"
import { Form, Formik } from 'formik';
import clsx from 'clsx';
import CustomDatePickerLab from '../CustomFields/CustomDatePickerLab';
import CustomErrorMessage from '../CustomFields/CustomErrorMessage';
import { CP_INVALIDO, FECHA_VALIDA, INTER_CONTRATANE, MAX_LENGTH_CP, TIPO_FLUJO, VALOR_NECESARIO } from '../Utils/Constantes';
import { calcularEdad, generoValueToService, maxLength, serviceToGeneroValue, validaResponse } from '../Utils/Utils';
import Api from '../Api/Api';
import CircularProgress from '@mui/material/CircularProgress';

export default function SoloAM(props) {
  const navigate = useNavigate();
  const [datos, setDatos] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [paso, setPaso] = useState(0);
  const [pasoGenero, setPasoGenero] = useState(false);
  const [pasoCP, setPasoCP] = useState(false);
  const [pasoEmbarazo, setPasoEmbarazo] = useState((props.asegurado && serviceToGeneroValue(props.asegurado.agregado.genero) === 1 ?
    (calcularEdad(new Date(props.asegurado.agregado.fechaNacimiento)) > 10 && calcularEdad(new Date(props.asegurado.agregado.fechaNacimiento)) < 55 ? true : false) : false));
  const [isMuestraPregunta, setMuestraPregunta] = useState((props.asegurado && serviceToGeneroValue(props.asegurado.agregado.genero) === 1 ?
    (calcularEdad(new Date(props.asegurado.agregado.fechaNacimiento)) > 10 && calcularEdad(new Date(props.asegurado.agregado.fechaNacimiento)) < 55 ? true : false) : false));
  const [cotizar, setCotizar] = useState(false);
  const [titulo, setTitulo] = useState('Primero, dinos quién es el afortunad@');

  const handleSiguientePaso = (paso, values, setFieldError) => {
    if (values.nombre !== "") {
      setTitulo('Nos gustaría saber un poco  más de ' + values.nombre);
      setPaso(paso);
    } else {
      setFieldError("nombre", VALOR_NECESARIO);
    }
  }

  const handleChangeFechaNacimiento = (fecha, setFieldValue, setFieldError) => {
    setFieldValue("genero", null);
    setPasoGenero(false);
    setMuestraPregunta(false);
    setFieldValue('embarazo', null);
    setPasoEmbarazo(false);
    setFieldValue('cp', '');
    setPasoCP(false);
    if (fecha instanceof Date && !isNaN(fecha)) {
      setFieldValue("fechaNacimiento", fecha);
      setPasoGenero(true);
      //validacion pregunta embarazo
      if (calcularEdad(fecha) > 10 && calcularEdad(fecha) < 55) {
        setMuestraPregunta(true);
      }
    } else {
      setFieldError("fechaNacimiento", FECHA_VALIDA);
    }
  };

  const handleGenero = (genero, setFieldValue) => {
    setFieldValue('embarazo', null);
    setFieldValue('cp', '');
    setPasoEmbarazo(false);
    setPasoCP(false);
    setFieldValue("genero", genero);
    if (genero === 0) {
      setPasoCP(true);
      setFieldValue('cp', '');
      setPasoEmbarazo(false);
    } else {
      if (isMuestraPregunta) {
        setPasoEmbarazo(true);
      } else {
        setPasoCP(true);
      }
    }
  };

  const handleEmbarazo = (embarazo, setFieldValue) => {
    setFieldValue("embarazo", embarazo);
    setPasoCP(true);
  };

  const handleChangeCP = (event, setFieldValue, setFieldError) => {
    const cp = maxLength(event.target.value, MAX_LENGTH_CP);
    setFieldValue("cp", cp);
    if (cp.length === MAX_LENGTH_CP) {
      Api.validaCP(cp)
        .then(res => {
          if (validaResponse(res) && res.data.existe) {
            setCotizar(true);
          } else {
            setFieldError('cp', CP_INVALIDO);
          }
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      setCotizar(false);
    }
  };

  const handleContinuar = (values, setSubmitting) => {
    let contratante = {}, aseguradoTitular = {};
    const tipoFlujo = Number(window.sessionStorage.getItem(TIPO_FLUJO) ? window.sessionStorage.getItem(TIPO_FLUJO): props.tipoFlujo);
    if (window.sessionStorage.getItem(INTER_CONTRATANE)) {
      contratante = JSON.parse(window.sessionStorage.getItem(INTER_CONTRATANE));
      contratante.ultimoPaso = 1;
      contratante.tipoFlujo = tipoFlujo;
      aseguradoTitular.nombre = values.nombre;
      aseguradoTitular.fechaNacimiento = values.fechaNacimiento;
      aseguradoTitular.genero = generoValueToService(values.genero);
      aseguradoTitular.embarazo =  values.embarazo;
      aseguradoTitular.cp = values.cp;
      aseguradoTitular.titular = true;
      aseguradoTitular.indice = 0;
			//aseguradoTitular.parentesco = "Titular";
      contratante.asegurados = [].concat(aseguradoTitular);
      window.sessionStorage.setItem(INTER_CONTRATANE, JSON.stringify(contratante));      
      if(calcularEdad(new Date(values.fechaNacimiento)) > 70) {
        props.handleAdvertencias(1, true);
      } else 
      if(values.genero === 1 && values.embarazo) {
        props.handleAdvertencias(2, true);
      } else {
        Api.actualizaContratante(contratante.id, contratante)
        .then(res => {
          Api.getContratante(contratante.folio)
          .then(res => {
            window.sessionStorage.setItem(INTER_CONTRATANE,JSON.stringify(res.data.contratante));
            setSubmitting(false);
            //am
            navigate('/datos/alguien-mas/agregar-mas');
          })
          .catch(error => {
						setSubmitting(false);
            console.log(error);
          });
        })
        .catch(error => {
          setSubmitting(false);
          console.log(error);
        });
      }
    }
  };

  const handleRegresar = (value) => {
    switch (paso) {
      case 0:
        navigate('/bienvenida');
        break;
      case 1:
        setPasoGenero(false);
        setMuestraPregunta(false);
        setPasoEmbarazo(false);
        setPasoCP(false);
        setCotizar(false);
        setPaso(0);
        break;
      default:
        props.handleRegresar();
        break;
    }

  }

  useEffect(() => {
    if (window.sessionStorage.getItem(INTER_CONTRATANE)) {
      const contratante = JSON.parse(window.sessionStorage.getItem(INTER_CONTRATANE));
      if(contratante.asegurados.length > 0){
        const titular = contratante.asegurados.find(asegurado => asegurado.titular === true);
        if (titular && titular.fechaNacimiento) {
          setDatos(titular);
          setTitulo('Nos gustaría saber un poco  más de ' + titular.nombre);
          setPaso(1);
          setCotizar(true);
          setPasoGenero(true);
          if (titular) {
            setMuestraPregunta(true);
            setPasoEmbarazo(true);
          }
          setPasoCP(true);
        }
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
    /* Especifica cómo sanear este efecto:
    return function cleanup() {
    };*/
  }, []);

  return (
    <>
      { isLoading ? <CircularProgress />  :
        <>
          <IconButton className="back-button" onClick={handleRegresar}>
            <ArrowBackIcon />
          </IconButton>
          <Formik validateOnChange={true}
            initialValues={{
              nombre: (datos && datos.nombre ? datos.nombre : ''),
              fechaNacimiento: (datos && datos.fechaNacimiento ? new Date(datos.fechaNacimiento) : new Date()),
              genero: (datos && datos.genero ? serviceToGeneroValue(datos.genero) : ''),
              embarazo: (datos && datos.embarazo ? datos.embarazo : null),
              cp: (datos && datos.cp ? datos.cp : ''),
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              handleContinuar(values, setSubmitting);
            }}
            validationSchema={pasoEmbarazo ? validationEmbarazoForm : validationForm}>
            {({ values, submitForm, setFieldValue, handleChange, errors, isSubmitting, setFieldError }) => (
              <Form>
                <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} className="normalize-modal pX-60px">
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                    <p className="datos-txt">{titulo}</p>
                  </Grid>
                  {paso === 0 &&
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <div className="label-asegurado mX-10">¿C&oacute;mo se llama?</div>
                        <CustomTextField id="nombre" name="nombre" type="text" placeholder="Nombre" className="grid-item-input" />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                        <Button variant="contained" disableElevation endIcon={<ArrowForwardIcon />} className="button-continuar w-100"
                          onClick={() => handleSiguientePaso(1, values, setFieldError)}>
                          Continuar
                        </Button>
                      </Grid>
                    </>
                  }
                  {paso === 1 &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                      <p>¿Cu&aacute;ndo naci&oacute;?</p>
                      <CustomDatePickerLab id="fechaNacimiento" name="fechaNacimiento" type="text" placeholder="Fecha Nacimiento"
                        className="grid-item-input w-100"
                        disableFuture onChange={(newValue) =>
                          handleChangeFechaNacimiento(newValue, setFieldValue, setFieldError)}
                      />
                    </Grid>
                  }
                  {pasoGenero &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                      <p className="mX-10">¿C&uacute;al es su g&eacute;nero?</p>
                      <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          <Button variant="outlined" disableElevation
                            className={clsx({ "boton-form-seleccionado": (values.genero === 0) }, { "boton-form w-100": true })}
                            onClick={(event) => handleGenero(0, setFieldValue)}>
                            Hombre
                          </Button>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-end">
                          <Button variant="outlined" disableElevation
                            className={clsx({ "boton-form-seleccionado": (values.genero === 1) }, { "boton-form w-100": true })}
                            onClick={(event) => handleGenero(1, setFieldValue)}>
                            Mujer
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  }
                  {pasoEmbarazo &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                      <p className="mX-10">¿Est&aacute; embarazada?</p>
                      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          <Button variant="outlined" disableElevation
                            className={clsx({ "boton-form-seleccionado": (values.embarazo) }, { "boton-form w-100": true })}
                            onClick={(event) => handleEmbarazo(true, setFieldValue)}>
                            Si
                          </Button>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-end">
                          <Button variant="outlined" disableElevation
                            className={clsx({ "boton-form-seleccionado": (values.embarazo === false) }, { "boton-form w-100": true })}
                            onClick={(event) => handleEmbarazo(false, setFieldValue)}>
                            No
                          </Button>
                        </Grid>
                        <CustomErrorMessage name="embarazo" />
                      </Grid>
                    </Grid>
                  }
                  {pasoCP &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                      <p className="fecha-nacimiento">¿C&uacute;al es su c&oacute;digo postal?</p>
                      <CustomTextField id="cp" name="cp" type="text" placeholder="C.P." className="grid-item-input"
                        onChange={(event) => handleChangeCP(event, setFieldValue, setFieldError)} />
                    </Grid>
                  }
                  {cotizar &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                      <Button variant="outlined" disableElevation
                        className="boton-submit boton-form-seleccionado" onClick={submitForm} disabled={isSubmitting}>
                        COTIZAR
                      </Button>
                    </Grid>
                  }
                </Grid>
              </Form>
            )}
          </Formik>
        </>
      }
    </>
  );
}